import React, {useEffect} from "react";
import GenericItem from "../../../common/items/GenericItem";

const VriSplashPageNewUserItem = ({}) => {
    return (
        <>
            <img alt={`vri-banner`}
                 className={'splash-banner-img'}
                 src={'../images/vri-banner.png'}/>
            <GenericItem title={i18n.payments.productNotes}
                         testid={'newUserVRIProductNotesItem'}
                         details={i18n.payments.vri.productNote}/>

            <br/>

            <div style={{ fontSize: '1.2em' }}>
                It is a cost-effective solution designed to enhance performance and accountability across diverse industries, tailored to industries including Guard Patrol, Correctional Facilities, Healthcare, Agriculture, Sanitation, and Logistics.
                <br/><br/>
                Customers currently utilizing Videx’s existing data collection hardware can effortlessly transition to this new software solution.
                <br/><br/>

                <div className={'plan-sub-title'}>With Videx Route Inspector, you’ll be able to:</div>
                <ul>
                    <li>
                        Bring Your Own iButtons, Barcodes, and RFID Tags
                    </li>
                    <li>
                        Create Routes with Flexible Tour Schedules
                    </li>
                    <li>
                        Ensure Your Inspectors are on Location with GPS Verification (only on Mobile Devices)
                    </li>
                    <li>
                        View Comprehensive Reports and Analytics from Anywhere
                    </li>
                </ul>

                <div className={'plan-sub-title'}>Key Features:</div>
                <ul>
                    <li>
                        Powerful and User Friendly
                    </li>
                    <li>
                        Cloud Hosted Software – No Installation Required
                    </li>
                    <li>
                        Compatible with Videx Data Collection Hardware
                    </li>
                    <li>
                        Integration with Videx Mobile Applications
                    </li>
                </ul>
                <br/>

                <div className={'row'}>
                    <div className={'col-6'}>
                        <img alt={`vri-mobile`}
                             className={'splash-phone-img'}
                             src={'../images/vri-mobile.png'}/>
                    </div>
                    <div className={'col-6'}>
                        <div className={'plan-sub-title'}>Videx Route Inspector Mobile</div>
                        <ul>
                            <li>
                                Utilize mobile devices as a data collector, allowing organizations that permit mobile device usage to scan barcodes or RFID tags.
                            </li>
                            <li>
                                Administrators can configure routes to require location verification of scanned items, thereby enhancing accountability, ensuring that routes are meticulously executed.
                            </li>
                            <li>
                                Videx Route Inspector Mobile is available on iOS and Android Devices.
                            </li>
                        </ul>
                    </div>
                </div>

                <br/><br/>

                <div className={'plan-sub-title'}>Videx Data Collection Hardware</div>
                <br/>
                For organizations with stringent regulations prohibiting mobile device usage, Videx Route Inspector is also compatible with Videx data collection hardware, including TouchProbe Blue, TouchProbe, CyberBadge, and iBR9000.

                <br/><br/>

                <img alt={`videx-hardware`}
                     className={'splash-banner-img'}
                     src={'../images/videx-hardware.png'}/>
            </div>
        </>
    );
}

export default VriSplashPageNewUserItem;